module.exports = __webpack_public_path__ + "static/img/bg_data.bb6c336a.png";